import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { EASE, Overline, Reveal } from "@/components/motion";

const STEPS = [
  {
    num: "01",
    title: "Ajanı Kurun",
    desc: "Yönetmek istediğiniz cihazlara hafif ajanı dakikalar içinde kurun. Toplu dağıtım seçenekleriyle yüzlerce cihaz tek seferde hazır.",
  },
  {
    num: "02",
    title: "Cihazlar Bağlansın",
    desc: "Cihazlarınız otomatik olarak panele kaydolur. Gruplandırın, etiketleyin, envanterinizi anında görün.",
  },
  {
    num: "03",
    title: "Her Yerden Yönetin",
    desc: "Tarayıcınızı açın, giriş yapın. İzleyin, müdahale edin, destek verin. Ofiste, evde, yolda — fark etmez.",
  },
];

export default function HowItWorks() {
  const lineRef = useRef(null);
  const inView = useInView(lineRef, { once: true, margin: "-120px" });

  return (
    <section
      id="nasil-calisir"
      data-testid="how-it-works-section"
      className="border-y border-black/5 bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-16 max-w-2xl md:mb-24">
          <Reveal>
            <Overline>Nasıl Çalışır</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl font-bold tracking-tighter text-[#0A0A0A] sm:text-5xl lg:text-6xl">
              Üç adımda
              <br />
              <span className="text-[#003366]">tam kontrol.</span>
            </h2>
          </Reveal>
        </div>

        <div ref={lineRef} className="relative grid gap-12 md:grid-cols-3 md:gap-8">
          <svg
            className="pointer-events-none absolute left-0 top-6 hidden h-1 w-full md:block"
            aria-hidden="true"
            preserveAspectRatio="none"
            viewBox="0 0 100 1"
          >
            <motion.line
              x1="0"
              y1="0.5"
              x2="100"
              y2="0.5"
              stroke="#003366"
              strokeWidth="1"
              strokeOpacity="0.25"
              vectorEffect="non-scaling-stroke"
              initial={{ pathLength: 0 }}
              animate={inView ? { pathLength: 1 } : {}}
              transition={{ duration: 1.8, ease: EASE }}
            />
          </svg>

          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={0.2 + i * 0.15} className="relative">
              <div
                data-testid={`step-${s.num}`}
                className="relative border-t-2 border-transparent pt-8"
              >
                <span
                  className="absolute -top-[5px] left-0 h-2 w-2 rounded-full bg-[#003366]"
                  aria-hidden="true"
                />
                <span className="font-display text-sm font-bold tracking-[0.3em] text-[#336699]">
                  {s.num}
                </span>
                <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-[#0A0A0A]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#525252] md:text-base">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
